import * as firebase from 'firebase/app';

import { AngularFireStorage, AngularFireStorageReference } from '@angular/fire/storage';
import { Observable, from, of, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

import { AngularFireAuth } from '@angular/fire/auth';
import { ErrorsHandler } from '@app/core/errors/errors-handler';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {HttpClient} from "@angular/common/http";
import {Utils} from "../../../utils";
import {Assistance} from "../../../models/assistance";
import {AngularFireDatabase} from "@angular/fire/database";

export interface IFileMetaData {
  meta: any;
  url: string;
}

@Injectable()
export class FirebaseService {
  public token: string;

  constructor(
    private authFireService: AngularFireAuth,
    private AFStorage: AngularFireStorage,
    private db: AngularFireDatabase,
    private httpClient: HttpClient,
    private errorsHandler: ErrorsHandler) {
  }

  uploadFile(files, name) {
    const file = files[0];
    return this.AFStorage.upload(name, file);
  }

  uploadBlob(path: string, blob: Blob): Observable<firebase.storage.UploadTaskSnapshot> {
    return from(firebase.storage().ref(path).put(blob));
  }

  deleteFile(name) {
    return this.AFStorage.ref(name).delete().pipe(
      catchError((error) => of(error))
    );
  }

  getStorageFileRef(name): Observable<any> {
    return this.AFStorage.ref(name).getDownloadURL().pipe(
        catchError((error) => of(''))
      );
  }

  getFileRef(name): AngularFireStorageReference {
    return this.AFStorage.ref(name);
  }

  sendVideocallRequest(assistance: Assistance, operatorId: string, pin: string) {

    const messageId = new Date().getTime() + Utils.randomString(2);

    this.db.database.ref('messaging/tickets/ticket_' + assistance.id + '/100/messages/').child(messageId).set({
      deleted: false,
      fromID: operatorId,
      messageID: messageId,
      sentAt: new Date().getTime(),
      type: 100,
      card: {
        button: {
          text: 'CONTINUA',
          type: 'videoCall'
        },
        info: [{ label: 'Inquadra il QR per iniziare' }],
        leftIcon: {
          type: 'new_assistance'
        },
        qrCode: `${pin};ev:${assistance.id}`,
        title: 'Richiesta videochiamata',
        type: 'videoCall'
      },
    });

  }

  async getMediaMetaData(data: firebase.storage.UploadTaskSnapshot): Promise<IFileMetaData> {
    try {
      const metadata: IFileMetaData = {
        meta: '',
        url: ''
      };

      const meta = await data.ref.getMetadata();
      metadata.meta = meta;
      const url = await data.ref.getDownloadURL();
      metadata.url = url;
      return metadata;
    } catch (e) {
      console.log('Error media build', e);
    }
  }

  public async getChatMediaDownloadLink(ticketId: string, mediaId: string, extension: string): Promise<string> {
    return await this.AFStorage.ref(`chat/${ticketId}/100/${mediaId}.${extension}`).getDownloadURL().toPromise();
  }

}
